/**
 * 存储键名定义
 * @module constants/storage-keys
 *
 * 注意：这些 key 不带前缀，BrowserStorage 会自动添加配置的前缀
 * 例如：配置 prefix='nano_' 时，TOKEN 的实际 key 为 'nano_token'
 */

export const STORAGE_KEYS = {
  // ============================================
  // 认证相关
  // ============================================
  /** Token */
  TOKEN: 'token',
  /** 用户信息 */
  USER_INFO: 'user_info',
  /** 二维码信息 */
  QR_CODE: 'qr_code',

  // ============================================
  // 用户相关
  // ============================================
  /** VIP 信息 */
  VIP_INFO: 'vip_info',
  /** 积分信息 */
  POINTS_INFO: 'points_info',
  /** 任务列表 */
  TASKS: 'tasks',

  // ============================================
  // 支付相关
  // ============================================
  /** 套餐列表 */
  PACKAGES: 'packages',
  /** 当前订单 */
  CURRENT_ORDER: 'current_order',
  /** 优惠券列表 */
  COUPONS: 'coupons',

  // ============================================
  // 设备相关（与 v2 保持一致）
  // ============================================
  /** 设备码（存储格式：{deviceCode, ekey, softId, source}） */
  DEVICE_CODE: 'csd_device_code',
  /** 设备密钥（独立 key，兼容旧版） */
  EKEY: 'ekey',
  /** 软件 ID（独立 key，兼容旧版） */
  SOFT_ID: 'soft_id',

  // ============================================
  // 来源追踪
  // ============================================
  /** 来源信息 */
  SOURCE: 'source',
  /** 360 点击 ID */
  QHCLICKID: 'qhclickid',
  /** 百度 VID */
  BD_VID: 'bdVid',
  /** 推广策略 */
  STRATEGY: 'strategy',
  /** 小程序标识 */
  MP: 'mp',

  // ============================================
  // 事件追踪
  // ============================================
  /** 安装状态 */
  INSTALL_STATUS: 'install_status',
  /** 在线时长 */
  ONLINE_TIME: 'online_time',

  // ============================================
  // 邀请相关
  // ============================================
  /** 邀请人 ID */
  INVITE_ID: 'invite_id',

  // ============================================
  // 配置相关
  // ============================================
  /** 配置信息 */
  CONFIG: 'config',
  /** 语言设置 */
  LANGUAGE: 'language'
} as const

/** 存储键名类型 */
export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]
